import styled, { keyframes } from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const Scene = styled.div`
  position: relative;
  width: 100%;
`;

export const Viz = styled.div`
  position: relative;
  overflow: visible;
  box-sizing: border-box;
`;

export const Atmo = styled.div`
  position: absolute;
  inset: -6% -4% -10% -4%;
  pointer-events: none;
  overflow: visible;
  z-index: 0;
`;

const drift1 = keyframes`
  from { transform: translate(0, 0) scale(1); }
  to { transform: translate(70px, 50px) scale(1.12); }
`;

const drift2 = keyframes`
  from { transform: translate(0, 0) scale(1.05); }
  to { transform: translate(-60px, 70px) scale(0.95); }
`;

const drift3 = keyframes`
  from { transform: translate(0, 0); }
  to { transform: translate(50px, -40px); }
`;

export const Blob = styled.div`
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.36;
  will-change: transform;

  ${(props) => props.$paused && `animation-play-state: paused;`}
`;

export const Blob1 = styled(Blob)`
  width: 520px;
  height: 520px;
  left: -120px;
  top: -160px;
  background: radial-gradient(
    circle at 40% 40%,
    rgba(0, 215, 215, 0.4),
    transparent 62%
  );
  animation: ${drift1} 26s ease-in-out infinite alternate;
`;

export const Blob2 = styled(Blob)`
  width: 480px;
  height: 480px;
  right: -120px;
  top: 40px;
  background: radial-gradient(
    circle at 55% 45%,
    rgba(20, 214, 77, 0.32),
    transparent 62%
  );
  animation: ${drift2} 32s ease-in-out infinite alternate;
`;

export const Blob3 = styled(Blob)`
  width: 360px;
  height: 360px;
  left: 34%;
  bottom: -200px;
  background: radial-gradient(
    circle at 50% 50%,
    rgba(132, 241, 30, 0.16),
    transparent 62%
  );
  animation: ${drift3} 24s ease-in-out infinite alternate;
`;

export const SceneInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: none;
  margin: 0 auto;
  width: 100%;
`;

export const Frame = styled.div`
  background: none;
  border: 0;
  border-radius: 0;
  padding: 0;
  box-shadow: none;

  svg {
    width: 100%;
    display: block;
  }
`;

export const FrameTop = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

export const FrameTitle = styled.span`
  font-family: ${getToken('font-family-default')};
  font-size: 13px;
  font-weight: 700;
  color: ${homeColor.white};
  letter-spacing: 0.01em;
`;

export const Chips = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

export const Chip = styled.span`
  position: absolute;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(8, 23, 29, 0.86);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 6px 9px;
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  font-size: 10px;
  color: ${homeColor.white};
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.55);
  opacity: 0;
  transform: translateY(8px);
  transition:
    opacity 0.6s ease,
    transform 0.6s ease;
  white-space: nowrap;

  ${(props) =>
    props.$show &&
    `
    opacity: 1;
    transform: translateY(0);
  `}

  ${screen.md} {
    padding: 8px 12px;
    font-size: 11px;
  }
`;

export const ChipDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${(props) => (props.$human ? homeColor.amber : homeColor.green)};
  flex: none;
  box-shadow: ${(props) =>
    props.$human
      ? '0 0 7px rgba(245, 181, 68, .9)'
      : '0 0 7px rgba(20, 214, 77, .9)'};
`;

export const ChipTime = styled.small`
  color: ${homeColor.muted2};
  margin-left: 2px;
  font-weight: 500;
`;
